export { default } from './PartChangeChip';
